const e = {
  name: "GraphUp",
  dimensions: { width: 21, height: 20 },
  content: `
    <svg fill="currentColor">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M20.9201 0.62C20.8201 0.38 20.6201 0.18 20.3801 0.0799999C20.2601 0.03 20.1301 0 20.0001 0H15.0001C14.4501 0 14.0001 0.45 14.0001 1C14.0001 1.55 14.4501 2 15.0001 2H17.5901L9.00006 10.59L5.71006 7.3C5.32006 6.91 4.69006 6.91 4.30006 7.3L1.29006 10.29C0.900059 10.68 0.900059 11.31 1.29006 11.7C1.68006 12.09 2.31006 12.09 2.70006 11.7L4.99006 9.41L8.28006 12.7C8.67006 13.09 9.30006 13.09 9.69006 12.7L19.0001 3.41V6C19.0001 6.55 19.4501 7 20.0001 7C20.5501 7 21.0001 6.55 21.0001 6V1C21.0001 0.87 20.9701 0.74 20.9201 0.62Z" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M5 13C4.45 13 4 13.45 4 14V19C4 19.55 4.45 20 5 20C5.55 20 6 19.55 6 19V14C6 13.45 5.55 13 5 13Z" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8 17C8 16.45 8.45 16 9 16C9.55 16 10 16.45 10 17V19C10 19.55 9.55 20 9 20C8.45 20 8 19.55 8 19V17Z" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M13 14C12.45 14 12 14.45 12 15V19C12 19.55 12.45 20 13 20C13.55 20 14 19.55 14 19V15C14 14.45 13.55 14 13 14Z" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M16 10C16 9.45 16.45 9 17 9C17.55 9 18 9.45 18 10V19C18 19.55 17.55 20 17 20C16.45 20 16 19.55 16 19V10Z" />
    </svg>
  `
};
export {
  e as GraphUp
};
